interface ObjectDetailsState {
  isOpen: boolean
}

interface GraphRootState {
  graph?: {
    objectDetails?: ObjectDetailsState
  }
}

const defaultObjectDetailsState: ObjectDetailsState = {
  isOpen: false,
}


const selectObjectDetails = (state: Record<string, unknown>): ObjectDetailsState => {
  const graph = (state as GraphRootState).graph
  return graph?.objectDetails ?? defaultObjectDetailsState
}

export default selectObjectDetails
